import {
  Errors, ErrorTypes, flattenErrorTypeArray, groupErrorsByNonProperty, useStyledTheme,
} from '@equifinance/shared';

export default function useErrorBasedRowStyles(errors: Errors, warnings: Errors) {
  const theme = useStyledTheme();

  return [
    {
      when: (row: any) => {
        const recordWarnings = flattenErrorTypeArray(warnings?.[row?.id] ?? []);
        const filteredWarnings = groupErrorsByNonProperty(recordWarnings);
        const referWarnings = filteredWarnings?.[ErrorTypes.Refer] ?? [];
        const warningWarnings = filteredWarnings?.[ErrorTypes.Warning] ?? [];
        return referWarnings.length > 0 || warningWarnings.length > 0;
      },
      style: {
        backgroundColor: `${theme.colours.secondary[6]} !important`,
      },
    },
    {
      when: (row: any) => {
        const recordErrors = flattenErrorTypeArray(errors?.[row?.id] ?? []);
        const filteredErrors = groupErrorsByNonProperty(recordErrors);
        const rejectDataErrors = filteredErrors?.[ErrorTypes.RejectData] ?? [];
        return rejectDataErrors.length > 0;
      },
      style: {
        backgroundColor: `${theme.colours.danger[2]} !important`,
      },
    },
  ];
}
